export enum BackupOnboardingRoutesEnum {
  NotificationSettings = 'notification-settings',
  StorageSettings = 'storage-settings',
  Summary = 'summary',
  Details = 'details',
}
